module.exports = __webpack_public_path__ + "static/media/W5390484_5.ccf103e9.jpg";